import * as Yup from 'yup';
import { Auth } from '@caddyshack/common';

const { PasswordRequirements } = Auth;

const passwordMessages = {
  required: 'Password is required',
  newPassword: 'New password is required',
  repeatRequired: 'Repeat new password is required',
  min: 'Password must have at least 8 characters',
  noMatch: "Password doesn't match",
  max: 'Password must have no more than 32 characters',
  upperCase: 'Password must have at least 1 upper case letter',
  lowerCase: 'Password must have at least 1 lower case letter',
  special: 'Password must have at least 1 special character or number',
};

export const securityFormValidation = Yup.object().shape({
  oldPassword: Yup.string().required(passwordMessages.required),
  password: Yup.string()
    .oneOf([Yup.ref('password'), null], passwordMessages.noMatch)
    .min(PasswordRequirements.min, passwordMessages.min)
    .max(PasswordRequirements.max, passwordMessages.max)
    .matches(PasswordRequirements.upperCase, passwordMessages.upperCase)
    .matches(PasswordRequirements.lowerCase, passwordMessages.lowerCase)
    .matches(PasswordRequirements.special, passwordMessages.special)
    .required(passwordMessages.newPassword),
  repeatPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], passwordMessages.noMatch)
    .min(8, passwordMessages.min)
    .required(passwordMessages.repeatRequired),
});
